import Vue from 'vue';
import Vuex, { mapGetters } from 'vuex';
import * as actions from './actions';
import createLogger from 'vuex/dist/logger';
import user from './modules/user';
import topInfo from './modules/topInfo';
import lang from './modules/lang';
import logoutForced from './modules/logoutForced';
import loginError from './modules/loginError';
import webview from './modules/webview';
import screenWidth from './modules/screenWidth';
import cmk from './modules/cmk';
import dialog from './modules/dialog';

Vue.use( Vuex );

const debug = process.env.NODE_ENV !== 'production';

const store = new Vuex.Store({

    actions,
    modules: {

        user,
        topInfo,
        lang,
        logoutForced,
        loginError,
        webview,
        screenWidth,
        cmk,
        dialog

    },
    strict: debug,
    plugins: debug ? [createLogger()] : []

});

store.watch(( _, getters ) => getters.dialogCount, ( newVal ) => {

    if ( newVal === 0 ) {

        document.documentElement.classList.remove( 'dialogActivated' );

    } else {

        if ( !document.documentElement.classList.contains( 'dialogActivated' )) {

            document.documentElement.classList.add( 'dialogActivated' );

        }

    }

});

export default store;
